// extracted by mini-css-extract-plugin
module.exports = {"carousel-full-height":"HeroCarousel_carousel-full-height__X8hJT","carousel-dots":"HeroCarousel_carousel-dots__toBW_"};